import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
    isModalLoaderVisible: boolean;
    isModalOpen: boolean;
    modalTitle: string;
    modalMessage: string;
}

const initialState: State = {
    isModalLoaderVisible: false,
    isModalOpen: false,
    modalTitle: "",
    modalMessage: "",
};

const modalWindowSlice = createSlice({
    name: "modalWindow",
    initialState,
    reducers: {
        setModalTitle: (state, action: PayloadAction<string>) => {
            state.modalTitle = action.payload;
        },
        setModalMessage: (state, action: PayloadAction<string>) => {
            state.modalMessage = action.payload;
        },
        setIsModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isModalOpen = action.payload;
        },
        setModalLoaderVisibility: (state, action: PayloadAction<boolean>) => {
            state.isModalLoaderVisible = action.payload;
        },
    },
});

export const getModalTitle = (state: { modalWindowReducer: State }): string => {
    return state.modalWindowReducer.modalTitle;
};

export const getModalMessage = (state: {
    modalWindowReducer: State;
}): string => {
    return state.modalWindowReducer.modalMessage;
};

export const getIsModalOpen = (state: {
    modalWindowReducer: State;
}): boolean => {
    return state.modalWindowReducer.isModalOpen;
};

export const getIsModalLoaderVisible = (state: {
    modalWindowReducer: State;
}): boolean => {
    return state.modalWindowReducer.isModalLoaderVisible;
};

export const {
    setModalTitle,
    setModalMessage,
    setIsModalOpen,
    setModalLoaderVisibility,
} = modalWindowSlice.actions;

export default modalWindowSlice.reducer;
